import React from 'react';

const NoMatch = () => {
  return (
    <div>
      Oh buddy, you must be lost. Go home Dave, you're drunk!
    </div>
  );
};

export default NoMatch;